export default __webpack_public_path__ + "static/media/work5.8d3eba49.jpeg";